import {
	Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges,
	SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, QueryList,
	ViewChild, ViewChildren, ElementRef
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { IpAddress, DeviceFilter } from 'DiscoveryEngine.TS/Core';
import { ViewerDeviceFilterDto } from 'UvExplorerServer.Dtos.TS/Viewer';
import { DisplayDeviceListDto, DisplayDeviceListEntryDto } from 'UvExplorerServer.Dtos.TS/Session';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { Iterable } from 'DiscoveryEngine.TS/Utils';
import { DeviceFilterService } from 'netview';
import { NavLocation, NavigationService, NetFacadeService } from 'netview';
import { DiscResultsService } from 'discovery';
import { IdentityService } from 'identity';
import { MessageService } from 'base';
//import { Table } from 'primeng/table';
import { UvTable } from 'widget';
import { Dialog } from 'primeng/dialog';


export class DeviceSelectorEntry {
	public dataKey: string;
	public name: string;
	public ipAddress: string;
	public description: string;

	public ipAddressTag: IpAddress;
	public get hasIpAddressTag(): boolean {
		return !!this.ipAddressTag;
	}

	public deviceTag: DisplayDeviceListEntryDto;
	public get hasDeviceTag(): boolean {
		return !!this.deviceTag;
	}

	constructor() {
		this.dataKey = "";

		this.name = "";
		this.ipAddress = "";
		this.description = "";

		this.ipAddressTag = null;

		this.deviceTag = null;
	}
}


@Component({
	selector: 'device-selector',
	templateUrl: './device-selector.component.html',
	styleUrls: ['./device-selector.component.scss'],
	//changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceSelectorComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	public header: string;

	@Input()
	public visible: boolean;

	@Input()
	public minDevices: number;

	@Input()
	public maxDevices: number;

	@Input()
	public requireConfig: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<DisplayDeviceListEntryDto[]>

	@Output()
	public onCancel: EventEmitter<any>;

	@ViewChild('dialog', { static: true })
	public dialog: Dialog;

	@ViewChild('table', { static: true })
	// public table: Table;
	public table: UvTable;

	@ViewChildren('filter')
	public filters: QueryList<ElementRef<HTMLInputElement>>;

	private devices: DisplayDeviceListDto;

	public cols: any[];
	public entries: DeviceSelectorEntry[];
	public filterEntries: any[];
	public first: number;

	public selectedFilter: ViewerDeviceFilterDto;
	public selectedDevices: any;

	private networkLoadedSub: Subscription;

	public devicesLoading: boolean;

	private readonly DefaultFilter = "<All Devices>";

	public readonly VirtualScrollItemSize = 29;
	public get TableRowStyle(): string {
		return `height: ${this.VirtualScrollItemSize}px;`;
	}

	constructor(private changeDetector: ChangeDetectorRef,
		private deviceFilterService: DeviceFilterService,
		private navService: NavigationService,
		private netFacadeService: NetFacadeService,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private messageService: MessageService) {

		this.header = "";
		this.visible = false;
		this.minDevices = 1;
		this.maxDevices = 1;
		this.requireConfig = false;
		this.devices = null;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<DisplayDeviceListEntryDto[]>();
		this.onCancel = new EventEmitter<any>();
		this.cols = [
			{ field: 'name', header: 'Name', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
			{ field: 'ipAddress', header: 'IP Address', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
			{ field: 'description', header: 'Description', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
		];

		this.clearAll();

		this.networkLoadedSub = this.discResultsService.onNetworkLoaded.subscribe(
			() => {
				this.entries = [];
				this.filterEntries = [];
			},
			(error?) => {
				// ???
			});

		this.devicesLoading = false;
	}

	private clearAll(): void {
		this.entries = [];
		this.filterEntries = [];
		this.first = 0;

		this.clearSelectedDevices();
	}

	public doCustomSort(event): void {
		let comparer = function (a: DeviceSelectorEntry, b: DeviceSelectorEntry): number {
			let result = 0;

			switch (event.field) {
				case "ipAddress":
					if (a.ipAddressTag && b.ipAddressTag) {
						result = a.ipAddressTag.CompareTo(b.ipAddressTag);
					}
					else if (a.ipAddressTag) {
						result = 1;
					}
					else if (b.ipAddressTag) {
						result = -1;
					}
					break;
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public ngOnInit(): void {

	}
	
	public onActiveIndexChange(value: number): void {
		this.changeDetector.detectChanges();
	}

	public onFilterChange(): void {
		this.clearSelectedDevices();
	}

	private clearSelectedDevices(): void {
		this.selectedDevices = (this.maxDevices == 1 ? undefined : []);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		this.clearAll();

		change = changes["visible"];
		if (change) {
			if (this.visible) {
				this.rebuildFilterEntries();
				this.selectDefaultFilter();
				this.rebuildEntries();

				if (this.filters) {
					this.filters.forEach((filter: ElementRef<HTMLInputElement>) => {
						filter.nativeElement.value = "";
					});
				}

				if (this.table) {
					this.cols.forEach((col) => {
						this.table.filter("", col.field, col.filterMatchMode)
					});
				}

				// setTimeout(() => {
				// 	this.dialog.center();
				// 	setTimeout(() => {
				// 		this.dialog.center();
				// 		setTimeout(() => {
				// 			this.dialog.center();
				// 		}, 400);
				// 	}, 200);
				// }, 100);
			}
		}
	}

	public ngOnDestroy(): void {
		if (this.networkLoadedSub) {
			this.networkLoadedSub.unsubscribe();
			this.networkLoadedSub = null;
		}
	}

	private rebuildEntries(): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let filter: DeviceFilter = this.selectedFilter.DeviceFilter;

		this.devicesLoading = true;
		this.changeDetector.detectChanges();
		this.discResultsService.getFilteredDeviceList(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, "network", filter, null,
			false, false, false, false, this.requireConfig).subscribe(
				(result: DisplayDeviceListDto) => {
					this.devicesLoading = false;
					this.devices = result;
					this.entries = [];

					if (this.devices && this.devices.entries) {
						this.devices.entries.forEach((device: DisplayDeviceListEntryDto) => {
							let entry = new DeviceSelectorEntry();

							entry.dataKey = device.deviceGuid;
							entry.deviceTag = device;
							entry.name = device.name;

							entry.ipAddress = "";
							entry.ipAddressTag = null;
							if (device.ipAddress) {
								entry.ipAddress = device.ipAddress;
								entry.ipAddressTag = IpAddress.Create(device.ipAddress);
							}

							entry.description = device.systemDescription;

							this.entries.push(entry);
						}, this);
					}

					//this.changeDetector.markForCheck();
					this.changeDetector.detectChanges();
				},
				(error?) => {
					this.devicesLoading = false;
					this.messageService.displayErrorMessage("Could not retrieve filtered device list");
				});
	}

	private rebuildFilterEntries(): void {

		this.filterEntries = [];

		this.deviceFilterService.getBuiltInDeviceFilters().forEach((vdf: ViewerDeviceFilterDto) => {
			this.filterEntries.push({ index: this.filterEntries.length, name: vdf.DeviceFilter.Name, filter: vdf });
		}, this);

		let navLoc = this.navService.location;
		if (navLoc && navLoc.hasNetViewGuid) {
			let network = this.netFacadeService.findNetwork(navLoc.netViewGuid);
			if (network) {
				network.DeviceFilters.ForEach((vdf: ViewerDeviceFilterDto) => {
					this.filterEntries.push({ index: this.filterEntries.length, name: vdf.DeviceFilter.Name, filter: vdf });
				}, this);
			}
		}

		this.selectedFilter = this.filterEntries[0].filter;
	}

	private selectDefaultFilter(): void {
		if (!!this.DefaultFilter) {
			for (let i = 0; i < this.filterEntries.length; ++i) {
				if (this.filterEntries[i].name === this.DefaultFilter) {
					this.selectedFilter = this.filterEntries[i].filter
					break;
				}
			}
		}
	}

	public onSelectedFilterChange(event): void {
		let index = event.target.value;
		this.selectedFilter = this.filterEntries[index].filter;

		this.clearSelectedDevices();
		this.rebuildEntries();
		this.first = 0;
	}

	public isOkEnabled(): boolean {
		if (this.maxDevices == 1) {
			return !!this.selectedDevices;
		}
		else {
			if (this.selectedDevices) {
				let len = this.selectedDevices.length;
				return (this.minDevices <= len && len <= this.maxDevices);
			}
			return false;
		}
	}

	public onOkClicked(): void {
		this.onOk.emit(this.getSelectedDevices());
		this.hide();
	}

	public onCancelClicked(): void {
		this.onCancel.emit();
		this.hide();
	}

	private getSelectedDevices(): DisplayDeviceListEntryDto[] {
		let result: DisplayDeviceListEntryDto[] = [];
		if (this.selectedDevices) {
			if (Array.isArray(this.selectedDevices)) {
				this.selectedDevices.forEach((entry: DeviceSelectorEntry) => {
					result.push(entry.deviceTag);
				}, this);
			}
			else {
				let entry = <DeviceSelectorEntry>this.selectedDevices;
				result.push(entry.deviceTag);
			}
		}
		return result;
	}

	public get totalDeviceCount(): number {
		if (this.entries)
			return this.entries.length;
		else
			return 0;
	}

	public get selectedDeviceCount(): number {
		if (this.selectedDevices) {
			if (Array.isArray(this.selectedDevices)) {
				return this.selectedDevices.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}
}
